<template>
  <div class="main">
    <static-header />
    <notifications
      class="vue-notification-style"
      group="success"
      position="top left"
    />
    <notifications
      class="vue-notification-style"
      group="error"
      position="top left"
    />
    <router-view />
    <static-footer />
  </div>
</template>
<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import { mapActions, mapState } from "vuex";
import { inactivityListener } from "@/helper/inactivity";

export default {
  name: "App",
  components: {
    StaticHeader: Header,
    StaticFooter: Footer,
  },
  computed: {
    ...mapState("auth", ["authenticated"]),
  },
  created() {
    this.getUser();
    this.getCustomers();
    this.getPayment();
    // this.getNotifications();
    this.initializeCart(this.$store);
    this.initializeCustomer(this.$store);
    this.clearInactivityTimeout = inactivityListener(() => {
      if (this.authenticated) {
        this.Logout().then(() => {
          this.$router.push("/");
        });
      }
    }, 3600000);
  },
  destroyed() {
    this.clearInactivityTimeout && this.clearInactivityTimeout();
  },
  methods: {
    ...mapActions({
      initializeCart: "cart/initializeCart",
      initializeCustomer: "cart/initializeCustomer",
    }),
    ...mapActions("products", ["getProducts"]),
    ...mapActions("customers", ["getCustomers"]),
    ...mapActions("auth", ["getUser", "Logout", "getPayment"]),
  },
};
</script>
